module.exports = __webpack_public_path__ + "static/media/image8.58e597a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image8.jpg
// module id = 42
// module chunks = 0